import { SCREEN_SIZE } from '@dw/constants';
import { useScreenSize } from '@dw/hooks';
import { Stack, StackProps } from '@mui/material';
import { FunctionComponent } from 'react';

interface IHStackProps extends Omit<StackProps, 'columnGap' | 'rowGap' | 'gap'> {
  rowGap?: number;
  columnGap?: number | string;
  breakpoint?: SCREEN_SIZE | false;
  children: React.ReactNode;
}
export const HStack: FunctionComponent<IHStackProps> = (props: IHStackProps) => {

  const {
    rowGap = 2,
    columnGap = 2,
    children,
    breakpoint = SCREEN_SIZE.XS,
    ...stackProps
  } = props;

  const { currentSize } = useScreenSize();

  return (
    <Stack
      direction={breakpoint !== false && currentSize <= breakpoint ? 'column' : 'row'}
      columnGap={columnGap}
      rowGap={rowGap}
      alignItems={breakpoint === false || currentSize > breakpoint ? 'center' : undefined}
      {...stackProps}
    >
      {children}
    </Stack>
  )
}